
import Vue from 'vue'
export default Vue.extend({
  name: 'AuthLayout',
  mounted () {
    document.title = this.$t('app-title-sign-in') as string
  }
})
